export class ASDViewTypes {
    public static readonly ListView = '481a248d-c8d0-4cec-a62d-ade7611ea7f8';
    public static readonly EntityView = '1037c2c3-97dc-4635-8497-2e06b07c7aff';
    public static readonly CustomView = '33225457-fc8a-42ce-9b4d-53fea2224c5e';
    public static readonly CustomListView = '9c7440df-d1ec-4d54-8340-acf37b7c5430';
    public static readonly CustomEntityView = '67de134b-c2ab-4e78-885f-9bb730380c77';
    public static readonly Wizard = 'fd004bca-d51f-4d27-b222-493c41735a91';
    public static readonly WizardCustom = '25381089-36d1-445b-b4a8-1c5ab0d66dea';
  }
  